module.exports = {
  // 详情页的内容
  titleCardOptions: {
    titles: [
      { name: '服务详情', id: 'detail' },
      { name: '服务案例', id: 'example' }
    ],
    selectedLabel: 'detail',
    showMore: false,
    isSwitch: true
  },
  resultDetails: [
    {
      title: '贯标服务',
      contents: [
        '“贯标”对于企业来说，就是贯彻《企业知识产权管理规范》国家标准。企业知识产权管理规范的国家标准由国家知识产权局制订，经由国家质量监督检验检疫总局、国家标准化管理委员会批准颁布，于2013年3月1日起实施，标准号是GB/T29490-2013。'
      ]
    },
    {
      title: '贯标服务能力',
      contents: [
        `广州奥凯信息咨询有限公司贯标团队共15人，硕士以上学历8人，5年以上知识产权服务人员9人，全国专利师资人才1人，专利代理人3人，律师1人，其他体系审核员1人。服务的企业客户约900家，已通过认证约800家。企业所在行业主要为:医药健康、新材料、环保、新能源等，其中知名企业包括:美的、平安等。
        企业知识产权管理一体化解决方案`
      ]
    },
    {
      title: '企业知识产权管理一体化解决方案',
      contents: [
        `1. 壹专利检索分析系统
        集专利性和普适性于一身的智能化全球专利检索分析系统，为知识产权信息服务及科研创新提供实时情报信息。`,
        `2. 知识产权管理云平台
        从申请到转化的知识产权全生命周期线上管理，实现申请书、申请审批流程、费用、资助等流程事物的全程信息化管理行程完整专利。`,
        `3. 知识产权贯标认证
        旨在指导企业建立科学、系统、规范的知识产权管理体系，有效提高知识产权对企业经营发展的贡献水平。
        多产品系统融合，共同打造奥凯知识产权一站式服务平台，实现“管理-检索-分析-预警”的知识产权服务，旨在为企业提供知识产权“创造-保护-运用-管理”的“一体化”解决方案。`
      ]
    },
    {
      title: '贯标认证服务流程',
      contents: [
        `提交认证申请书→签订认证合同→第一阶段审核（包括文件评审）→问题整改→第二阶段审核→不符合项的跟踪整改→认证决定→颁发认证证书。`
      ]
    }
  ]
}